export interface AlertI {
  message: string;
  type: string;
  color: string;
}

export interface BusinessI {
  id: number;
  name: string;
}

export interface RootStateI {
  showSidebar: boolean;
  alert: AlertI;
  business: BusinessI | null;
}

export interface FindI {
  limit: string;
  page: string;
  [key: string]: any;
}

export interface ResultsI {
  total: number;
  data: any[];
  perPage: number;
  page: number;
  totalPages: number;
}

export const state: RootStateI = {
  showSidebar: false,
  alert: {
    message: '',
    type: '',
    color: '',
  },
  business: null,
};
